import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { injectIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";
import { FormGroup, Tab, NavItem, Row, Col, Nav } from "react-bootstrap";

import IncrementBtn from './IncrementBtn';
import FooterButton from "./FooterButton";
import SidePanel from "./SidePanel";

import { imageCdnUrl } from "../../config";
import update from "./update";

import DefaultIcon from "/public/SiteIcons/defaultIcon.svg";
import s from "./ListPlaceStep1.css";
import bt from "../../components/commonStyle.css";
import messages from "../../locale/messages";
import {
  FENCE_HEIGHT_START,
  FENCE_HEIGHT_END,
  FENCE_HEIGHT_INTERVAL,
  FENCING_HEIGHT_OPTIONS,
  SECURE_DOG_AREA_TYPE,
  GATES_TYPE_OPTIONS,
  SIZE_OF_DOG_OPTIONS,
  NUMBER_OF_DOGS_OPTIONS,
  FENCE_CONDITION_OPTIONS,
} from "../../constants";

const FenceSlider = ({ input, label }) => {
  const generateOptions = (start, end, interval) => {
    const options = [];
    for (let val = start; val <= end; val += interval) {
      options.push(`${val}m`);
    }
    return options;
  };

  const options = generateOptions(
    FENCE_HEIGHT_START,
    FENCE_HEIGHT_END,
    FENCE_HEIGHT_INTERVAL
  );

  const currentIndex = options.indexOf(input.value);
  const defaultValue = `${FENCE_HEIGHT_START}m`;

  if (currentIndex === -1 && input.value !== defaultValue) {
    input.onChange(defaultValue);
  }

  return (
    <FormGroup className={s.sliderGroup}>
      <label className={s.sliderLabel}>{label}</label>
      <div className={s.sliderContainer}>
        <input
          type="range"
          min="0"
          max={options.length - 1}
          step="1"
          value={currentIndex !== -1 ? currentIndex : 0}
          onChange={(e) => {
            const newValue = options[parseInt(e.target.value)];
            input.onChange(newValue);
          }}
          className={s.customSlider}
        />
        <div className={s.sliderMarkers}>
          {options.map((option, index) => (
            <span key={index} className={s.marker}>
              {option}
            </span>
          ))}
        </div>
      </div>
    </FormGroup>
  );
};

class Page7 extends Component {
  static propTypes = {
    initialValues: PropTypes.object,
    fencingHeight: PropTypes.string,
    secureDogArea: PropTypes.string,
    secureDogAreaType: PropTypes.string,
    gates: PropTypes.string,
    gatesType: PropTypes.string,
    sizeOfDog: PropTypes.string,
    numberOfDogs: PropTypes.string,
    dogBeds: PropTypes.string,
    dogBed: PropTypes.string, // Renamed from dogBed
    doggyDoor: PropTypes.string,
    doggyDoorGap: PropTypes.string,
    gatesDescription: PropTypes.string, // Add this
    fencingDescription: PropTypes.string, // Add this
    fenceCondition: PropTypes.string, // Add this
    fenceType: PropTypes.string, // Add this
  };

  constructor(props) {
    super(props);
    this.state = {
      essentialsAmenities: [],
      safetyAmenities: [],
    };
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    if (listingFields) {
      this.setState({
        essentialsAmenities: listingFields.essentialsAmenities,
        safetyAmenities: listingFields.safetyAmenities,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;
    if (listingFields) {
      this.setState({
        essentialsAmenities: listingFields.essentialsAmenities,
        safetyAmenities: listingFields.safetyAmenities,
      });
    }
  }

  checkboxGroup = ({ label, name, options, input }) => (
    <ul className={cx(s.listContainer, s.safetyAmenitiesFlex)}>
      {options.map((option, index) => {
        if (option.isEnable === "1") {
          const isChecked = input.value.includes(option.id);
          return (
            <li className={cx("amenitiesCheckBox", s.flex)} key={index}>
              <div className={s.checkBoxOutline}>
                <div
                  className={cx(
                    s.amenitiesCheckBoxWrapper,
                    "darkModeAmenitiesCheckBoxWrapper",
                    {
                      [s.checked]: isChecked,
                      darkModeAmenitiesChecked: isChecked,
                    },
                    "svgImg"
                  )}
                  onClick={() => {
                    const newValue = [...input.value];
                    if (isChecked) {
                      newValue.splice(newValue.indexOf(option.id), 1);
                    } else {
                      newValue.push(option.id);
                    }
                    input.onChange(newValue);
                  }}
                >
                  <img
                    src={
                      option.image
                        ? imageCdnUrl + "/amenities/" + option.image
                        : DefaultIcon
                    }
                    className={cx(s.imgSection, "imgSectionRtl", {
                      darkModeFilterNone: !!option.image,
                    })}
                  />
                  <div className={s.checkoutText}>{option.itemName}</div>
                </div>
              </div>
            </li>
          );
        }
      })}
    </ul>
  );

  render() {
    const { handleSubmit, previousPage, nextPage, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;
    const { essentialsAmenities, safetyAmenities } = this.state;
    const { secureDogAreaValue, gatesValue, dogBedsValue, doggyDoorValue } = this.props;
    
    const dogBedsConfig = {
      itemName: '',
      otherItemName: '',
      startValue: 0,
      endValue: 10,
    };

    const doggyDoorConfig = {
      itemName: '',
      otherItemName: '',
      startValue: 0,
      endValue: 100,
    };

    return (
      <div className={s.grid}>
        <SidePanel
          title={formatMessage(messages.stepOneCommonHeading)}
          landingContent={formatMessage(messages.whatamenities)}
        />
        <div className={s.landingMainContent}>
          <form onSubmit={handleSubmit}>
            <Tab.Container
              id="tabs-with-dropdown"
              defaultActiveKey="first"
              className={"amenitiesTab"}
            >
              <Row className="clearfix">
                <Col sm={12}>
                  <Nav bsStyle="tabs">
                    <NavItem eventKey="first">
                      <FormattedMessage {...messages.aminities} />
                    </NavItem>
                    <NavItem eventKey="second">
                      <FormattedMessage {...messages.safetyamenities} />
                    </NavItem>
                  </Nav>
                </Col>
                <Col sm={12}>
                  <Tab.Content animation>
                    <Tab.Pane eventKey="first">
                      <FormGroup className={s.formGroup}>
                        <Field
                          name="amenities"
                          component={this.checkboxGroup}
                          options={essentialsAmenities}
                        />
                      </FormGroup>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <FormGroup className={s.formGroup}>
                        <Field
                          name="safetyAmenities"
                          component={this.checkboxGroup}
                          options={safetyAmenities}
                        />
                      </FormGroup>
                      <div className={s.borderSection}></div>

                      <div className={`row ${s.customInput}`}>
                        {/* LEFT COLUMN */}
                        <div className="col-md-6">
                          {/* 1. Fencing Height */}
                          <FormGroup className={s.formRow}>
                            <label className={s.formLabel}>
                              <FormattedMessage {...messages.fencingHeight} />
                            </label>
                            <Field
                              name="fencingHeight"
                              component="select"
                              className={`form-control ${s.customSelect}`}
                            >
                              {/* <option value="">Select fencing height</option> */}
                              {FENCING_HEIGHT_OPTIONS.map(({ value, label }) => (
                                <option key={value} value={value}>
                                  {label}
                                </option>
                              ))}
                            </Field>

                            {String(this.props.fencingHeightValue) === "7" && (
                              <Field
                                name="fencingDescription"
                                component="textarea"
                                className={`form-control mt-1 ${s.customSelect}`}
                                placeholder={formatMessage(messages.dogDescription)}
                            />
                            )}
                          </FormGroup>
                          <FormGroup className={s.formRow}>
                            <label className={s.formLabel}>
                              <FormattedMessage {...messages.secureDogArea} />
                            </label>
                            <div className={s.radioButtons}>
                              <Field name="secureDogArea" component="input" type="radio" value="yes" /> Yes
                              <Field name="secureDogArea" component="input" type="radio" value="no" /> No
                            </div>
                            {secureDogAreaValue === "yes" && (
                              <Field
                                name="secureDogAreaType"
                                component="select"
                                className={`form-control mt-1 ${s.customSelect}`}
                              >
                                <option value="">Select area</option>
                                {SECURE_DOG_AREA_TYPE.map(({ value, label }) => (
                                  <option key={value} value={value}>{label}</option>
                                ))}
                              </Field>
                            )}
                          </FormGroup>
                          <FormGroup className={s.formRow}>
                            <label className={s.formLabel}>
                              <FormattedMessage {...messages.gates} />
                            </label>

                            <div className={s.radioButtons}>
                              <Field name="gates" component="input" type="radio" value="yes" /> Yes
                              <Field name="gates" component="input" type="radio" value="no" /> No
                            </div>

                            {this.props.gatesValue === "yes" && (
                              <>
                                <Field
                                  name="gatesType"
                                  component="select"
                                  className={`form-control mt-1 ${s.customSelect}`}
                                >
                                  {/* <option value="">Select gate type</option> */}
                                  {GATES_TYPE_OPTIONS.map(({ value, label }) => (
                                    <option key={value} value={value}>{label}</option>
                                  ))}
                                </Field>

                                {/* Conditionally render textarea if 'Other' selected */}
                                {String(this.props.gatesTypeValue) === "8" && (
                                  <Field
                                    name="gatesDescription"
                                    component="textarea"
                                    className={`form-control mt-1 ${s.customSelect}`}
                                    placeholder={formatMessage(messages.dogDescription)}
                                  />
                                )}
                              </>
                            )}
                          </FormGroup>

                          <FormGroup className={s.formRow}>
                            <label className={s.formLabel}>
                              <FormattedMessage {...messages.sizeOfDog} />
                            </label>
                            <Field
                              name="sizeOfDog"
                              component="select"
                              className={`form-control mt-1 ${s.customSelect}`}
                            >
                              {/* <option value="">Select size</option> */}
                              {SIZE_OF_DOG_OPTIONS.map(({ value, label }) => (
                                <option key={value} value={value}>{label}</option>
                              ))}
                            </Field>
                          </FormGroup>
                        </div>

                        <div className={s.borderSectionVertical}></div>
                        {/* RIGHT COLUMN */}
                        <div className="col-md-6">

                          {String(this.props.fencingHeightValue) !== "5" && (
                            <FormGroup className={s.formRow}>
                              <label className={s.formLabel}>
                                <FormattedMessage {...messages.fenceCondition} />
                              </label>
                              <Field
                                name="fenceCondition"
                                component="select"
                                className={`form-control ${s.customSelect}`}
                              >
                                {FENCE_CONDITION_OPTIONS.map(({ value, label }) => (
                                  <option key={value} value={value}>
                                    {label}
                                  </option>
                                ))}
                              </Field>

                              {String(this.props.fenceConditionValue) === "6" && (
                                <Field
                                  name="fenceType"
                                  component="textarea"
                                  className={`form-control mt-1 ${s.customSelect}`}
                                  placeholder={formatMessage(messages.dogDescription)}
                                />
                              )}
                            </FormGroup>
                          )}

                          <FormGroup className={s.formRow}>
                            <label className={s.formLabel}>
                              <FormattedMessage {...messages.numberOfDogs} />
                            </label>
                            <Field
                              name="numberOfDogs"
                              component="select"
                              className={`form-control mt-1 ${s.customSelect}`}
                            >
                              {/* <option value="">Select number</option> */}
                              {NUMBER_OF_DOGS_OPTIONS.map(({ value, label }) => (
                                <option key={value} value={value}>{label}</option>
                              ))}
                            </Field>
                          </FormGroup>
                          <FormGroup className={s.formRow}>
                            <label className={s.formLabel}>
                              <FormattedMessage {...messages.dogBeds} />
                            </label>
                            <div className={s.radioButtons}>
                              <Field name="dogBeds" component="input" type="radio" value="yes" /> Yes
                              <Field name="dogBeds" component="input" type="radio" value="no" /> No
                            </div>
                            {dogBedsValue === "yes" && (
                              <Field
                                name="dogBed"
                                type="text"
                                className={s.incrementInput}
                                component={(inputProps) => (
                                  <IncrementBtn
                                    {...inputProps}
                                    className={s.doggyDoorGapInput}
                                    onChange={inputProps.input.onChange}
                                    labelSingular={dogBedsConfig.itemName}
                                    labelPlural={dogBedsConfig.otherItemName}
                                    minValue={dogBedsConfig.startValue}
                                    maxValue={dogBedsConfig.endValue}
                                    incrementBy={1}
                                  />
                                )}
                              />
                            )}
                          </FormGroup>
                          <FormGroup className={s.formRow}>
                            <label className={s.formLabel}>
                              <FormattedMessage {...messages.doggyDoor} />
                            </label>
                            <div className={s.radioButtons}>
                              <Field name="doggyDoor" component="input" type="radio" value="yes" /> Yes
                              <Field name="doggyDoor" component="input" type="radio" value="no" /> No
                            </div>
                            {doggyDoorValue === "yes" && (
                              <Field
                                name="doggyDoorGap"
                                type="text"
                                className={s.incrementInput}
                                component={(inputProps) => (
                                  <IncrementBtn
                                    {...inputProps}
                                    className={s.doggyDoorGapInput}
                                    onChange={inputProps.input.onChange}
                                    labelSingular={doggyDoorConfig.itemName}
                                    labelPlural={doggyDoorConfig.otherItemName}
                                    minValue={doggyDoorConfig.startValue}
                                    maxValue={doggyDoorConfig.endValue}
                                    incrementBy={1}
                                  />
                                )}
                              />
                            )}
                          </FormGroup>
                        </div>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>

            <FooterButton
              nextPage={nextPage}
              previousPage={previousPage}
              nextPagePath={"check-in-information"}
              previousPagePath={"map"}
              formPage={formPage}
              step={step}
            />
          </form>
        </div>
      </div>
    );
  }
}

Page7 = reduxForm({
  form: "ListPlaceStep1",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: update,
})(Page7);

const selector = formValueSelector("ListPlaceStep1");

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  
  initialValues: {
    ...state.listingFields.data?.dogFriendlyAmenities || {},
    fencingHeight: state.listingFields.data?.dogFriendlyAmenities?.fencingHeight || "",
    secureDogArea: state.listingFields.data?.dogFriendlyAmenities?.secureDogArea || "",
    secureDogAreaType: state.listingFields.data?.dogFriendlyAmenities?.secureDogAreaType || "",
    gates: state.listingFields.data?.dogFriendlyAmenities?.gates || "",
    gatesType: state.listingFields.data?.dogFriendlyAmenities?.gatesType || "",
    sizeOfDog: state.listingFields.data?.dogFriendlyAmenities?.sizeOfDog || "",
    numberOfDogs: state.listingFields.data?.dogFriendlyAmenities?.numberOfDogs || "",
    dogBed: state.listingFields.data?.dogFriendlyAmenities?.dogBed || "",
    dogBeds: state.listingFields.data?.dogFriendlyAmenities?.dogBeds || "",
    doggyDoor: state.listingFields.data?.dogFriendlyAmenities?.doggyDoor || "",
    doggyDoorGap: state.listingFields.data?.dogFriendlyAmenities?.doggyDoorGap || "",
    fencingDescription: state.listingFields.data?.dogFriendlyAmenities?.fencingDescription || "", // Add this
    gatesDescription: state.listingFields.data?.dogFriendlyAmenities?.gatesDescription || "", // Add this
    fenceCondition: state.listingFields.data?.dogFriendlyAmenities?.fenceCondition || "", // Add this
    fenceType: state.listingFields.data?.dogFriendlyAmenities?.fenceType || "", // Add this
  },
  secureDogAreaValue: selector(state, "secureDogArea"),
  gatesValue: selector(state, "gates"),
  dogBedsValue: selector(state, "dogBeds"),
  doggyDoorValue: selector(state, "doggyDoor"),
  fencingHeightValue: selector(state, 'fencingHeight'),
  gatesTypeValue: selector(state, 'gatesType'),
  fenceConditionValue: selector(state, 'fenceCondition'),
});

export default injectIntl(withStyles(s, bt)(connect(mapState)(Page7)));